import { ReactNode } from "react";

export interface ForProps<T> {
  items: T[];
  empty?: ReactNode;
  children: (
    item: T,
    index: number,
    items: T[],
    first: boolean,
    last: boolean,
    even: boolean,
    odd: boolean,
    length: number,
  ) => ReactNode;
}

function For<T>({ items, children, empty }: ForProps<T>) {
  if (empty && (!items || items.length === 0)) {
    return <>{empty}</>;
  }

  const length = items.length;
  return (
    <>
      {items.map((item, index) => {
        const first = index === 0;
        const last = index === length - 1;
        const even = index % 2 === 0;
        const odd = !even;

        return children(item, index, items, first, last, even, odd, length);
      })}
    </>
  );
}

export { For };
